<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <div>
            <div class="label-input">Section Background</div>
            <div class="mb-5 group-item">
              <div class="mb-5">
                <label class="font-weight-bold">Background Desktop</label>
                <UploadImage
                  @callback="obj => handleUploadImageBackground(obj)"
                  :image="{ imageSrc: fields.background.img }"
                  :height="`250`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveImageBackground"
                />
              </div>
              <div>
                <label class="font-weight-bold">Background Mobile</label>
                <UploadImage
                  @callback="obj => handleUploadImageBackgroundMobile(obj)"
                  :image="{ imageSrc: fields.background.imgMobile }"
                  :height="`250`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveImageBackgroundMobile"
                />
              </div>
              <v-row>
                <v-col cols="12" md="6">
                  <div class="">
                    <v-subheader class="pl-0"> Background Image Opacity </v-subheader>
                    <v-slider
                      v-model="fields.background.opacity"
                      class="align-center"
                      :step="0.1"
                      :max="1"
                      :min="0"
                      hide-details
                      thumb-label="always"
                    >
                    </v-slider>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center gap-3 mt-4">
                    <input
                      type="color"
                      name="background-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields.background.color"
                      @change="handleChangeBackgroundColor"
                    />
                    <v-text-field hide-details v-model="fields.background.color" label="Background Color" />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center gap-3 mt-4">
                    <input
                      type="color"
                      name="overlay-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields.overlay.color"
                      @change="handleChangeOverlayColor"
                    />
                    <v-text-field hide-details v-model="fields.overlay.color" label="Overlay Color" />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="">
                    <v-subheader class="pl-0"> Background Overlay Opacity </v-subheader>
                    <v-slider
                      v-model="fields.overlay.opacity"
                      class="align-center"
                      :step="0.1"
                      :max="1"
                      :min="0"
                      hide-details
                      thumb-label="always"
                    >
                    </v-slider>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <div class="label-input">Content</div>
          <div class="group-item mb-5">
            <div>
              <v-select v-model="fields.contentAlign" :items="alignOptions" label="Content Align" />
            </div>
            <div>
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                <label for="showRating" style="margin-bottom: 0" class="">Rating</label>
                <input type="checkbox" v-model="fields.rating.show" id="showRating" />
              </div>
              <v-row>
                <v-col cols="12" md="4">
                  <v-rating
                    color="warning"
                    background-color="#c1c1c1"
                    empty-icon="mdi-star-outline"
                    full-icon="mdi-star"
                    half-icon="mdi-star-half-full"
                    hover
                    length="5"
                    size="35"
                    :value="fields.rating.value"
                    @input="handleChangeRatingValue"
                  ></v-rating>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field v-model="fields.rating.text" label="Text" />
                </v-col>
              </v-row>
            </div>
            <div>
              <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                <label for="showTag" style="margin-bottom: 0" class="">Tag</label>
                <input type="checkbox" v-model="fields.tag.show" id="showTag" />
              </div>
              <div class="group-item mb-5">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="fields.tag.text" label="Tag Text" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="tag-background-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields.tag.background"
                        @change="handleChangeTagBackground"
                      />
                      <v-text-field v-model="fields.tag.background" label="Background Color" />
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div class="mb-3">
              <label class="label">Title</label>
              <ckeditor :editor="editor" v-model="fields.titleBanner.text" :config="editorConfig" />
            </div>
            <div>
              <label class="label">Content</label>
              <ckeditor :editor="editor" v-model="fields.contentBanner.text" :config="editorConfig" />
            </div>
          </div>

          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label for="showButton" style="margin-bottom: 0" class="label-input">Button</label>
            <input type="checkbox" v-model="fields.button.show" id="showButton" />
          </div>
          <div class="group-item mb-5" v-if="fields.button.show">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.button.text" label="Button Text" />
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.background"
                    @change="handleChangeButtonBackground"
                  />
                  <v-text-field v-model="fields.button.background" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.color"
                    @change="handleChangeButtonTextColor"
                  />
                  <v-text-field v-model="fields.button.color" label="Text Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <v-text-field v-model="fields.button.subButton" label="Sub Button" />
                </div>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="fields.button.link" label="Button Link" />
              </v-col>
            </v-row>
          </div>

          <div>
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label for="showFeatures" style="margin-bottom: 0" class="label-input">Features</label>
              <input type="checkbox" v-model="fields.features.show" id="showFeatures" />
            </div>
            <div class="group-item mb-5">
              <div class="">
                <v-select v-model="fields.features.colPerView" :items="colPerViewOptions" label="Columns per view" />
              </div>
              <div>
                <div class="d-flex justify-space-between align-center">
                  <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                    <label for="showBtn" style="margin-bottom: 0" class="label-input">Items</label>
                  </div>
                  <v-btn small text color="primary" @click="handleAddItem">
                    <v-icon size="16">mdi-plus</v-icon>
                    <span>Add Item</span>
                  </v-btn>
                </div>
                <v-expansion-panels accordion>
                  <v-expansion-panel v-for="(item, i) in fields.features.items" :key="i">
                    <v-expansion-panel-header>
                      <div class="d-flex justify-space-between align-center">
                        <span>Item {{ i + 1 }}</span>
                        <v-btn icon @click.stop="handleRemoveFeatureItem(i)">
                          <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="">
                        <div>
                          <UploadImage
                            @callback="obj => handleUploadImageFeatureItem(obj, i)"
                            :image="{ imageSrc: item.icon }"
                            :height="`250`"
                            :typeUpload="'image'"
                            @callbackDelete="handleRemoveUploadFeatureItem(i)"
                          />
                        </div>
                        <div class="item-text mt-5">
                          <ckeditor :editor="editor" v-model="item.text" :config="editorConfig" />
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>
          </div>

          <div>
            <div class="label-input">Common</div>
            <div class="group-item mb-5">
              <v-row>
                <v-col md="12" cols="12">
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="text-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields.textColor"
                      @change="handleChangeTextColorCommon"
                    />
                    <v-text-field v-model="fields.textColor" label="Text Color" />
                  </div>
                </v-col>
                <v-col md="6" cols="12">
                  <div class="d-flex align-center">
                    <v-checkbox v-model="fields.padding.top" label="Top Padding" />
                  </div>
                </v-col>
                <v-col md="6" cols="12">
                  <div class="d-flex align-center">
                    <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
export default {
  name: 'BannerB1',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      alignOptions: [
        {
          text: 'Left',
          value: 'left',
        },
        {
          text: 'Right',
          value: 'right',
        },
        {
          text: 'Center',
          value: 'center',
        },
      ],
      colPerViewOptions: [
        {
          text: '2',
          value: 2,
        },
        {
          text: '3',
          value: 3,
        },
        {
          text: '4',
          value: 4,
        },
      ],
      fields: {
        title: 'Banner B1 Section',
        textColor: '#ffffff',
        contentAlign: 'left',
        padding: {
          top: true,
          bottom: true,
        },
        overlay: {
          color: '#000000',
          opacity: 0,
        },
        background: {
          color: '',
          img: '',
          imgMobile: '',
          opacity: 0,
        },
        titleBanner: {
          show: false,
          text: '',
        },
        contentBanner: {
          show: false,
          text: '',
        },
        button: {
          text: '',
          show: false,
          link: '',
          background: '',
          color: '',
          subButton: '',
        },
        rating: {
          show: false,
          value: 0,
          text: '',
        },
        tag: {
          background: '',
          show: false,
          text: '',
        },
        features: {
          colPerView: 2,
          show: false,
          items: [],
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionBannerB1(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImageBackground(obj) {
      this.fields.background.img = obj.imageSrc;
    },
    handleRemoveImageBackground() {
      this.fields.background.img = '';
    },
    handleChangeBackgroundColor(event) {
      this.fields.background.color = event.target.value;
    },
    handleChangeOverlayColor(event) {
      this.fields.overlay.color = event.target.value;
    },
    handleChangeRatingValue(value) {
      this.fields.rating.value = value;
    },
    handleChangeButtonBackground(event) {
      this.fields.button.background = event.target.value;
    },
    handleChangeButtonTextColor(event) {
      this.fields.button.color = event.target.value;
    },
    handleAddItem() {
      this.fields.features.items.push({
        icon: '',
        text: '',
      });
    },
    handleRemoveFeatureItem(index) {
      this.fields.features.items.splice(index, 1);
    },
    handleUploadImageFeatureItem(obj, index) {
      this.fields.features.items[index].icon = obj.imageSrc;
    },
    handleRemoveUploadFeatureItem(index) {
      this.fields.features.items[index].icon = '';
    },
    handleChangeTagBackground(event) {
      this.fields.tag.background = event.target.value;
    },
    handleChangeTextColorCommon(event) {
      this.fields.textColor = event.target.value;
    },
    handleUploadImageBackgroundMobile(obj) {
      this.fields.background.imgMobile = obj.imageSrc;
    },
    handleRemoveImageBackgroundMobile() {
      this.fields.background.imgMobile = '';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
